import React, { Fragment, SyntheticEvent, useState } from 'react'
import { IConfiguration } from 'stores/Configuration'
import TextInput from 'atoms/Form/TextInput'
import Button from 'atoms/Button'

export const AdvocacyCodeCheck = ({ config }: { config: IConfiguration }) => {
  const [code, setCode] = useState('')
  const validateCode = async (e: SyntheticEvent) => {
    e.preventDefault()
    config.validateCampaignCodeAndSetAvailableProducts(code)
  }
  return (
    <Fragment>
      <h3 className="">Please input your unique voucher code to start your booking process.</h3>
      <p className="mb-5">Your voucher code can be found on your invitation. If you do not have your voucher code, please call your chosen centre.</p>
      <TextInput
        name="advocacyCode"
        label="Voucher Code"
        value={code}
        onChange={e => {
          setCode(e.currentTarget.value)
        }}
      ></TextInput>
      <Button disabled={!code} onClick={validateCode}>
        Confirm code
      </Button>
    </Fragment>
  )
}
